import { render } from "./AdminSpaceReservations.vue?vue&type=template&id=6341c1bb&scoped=true"
import script from "./AdminSpaceReservations.vue?vue&type=script&lang=js"
export * from "./AdminSpaceReservations.vue?vue&type=script&lang=js"

import "./AdminSpaceReservations.vue?vue&type=style&index=0&id=6341c1bb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6341c1bb"]])

export default __exports__